import { $, esc } from '../core/text.js';
import { accById } from '../progress/xp.js';

/* ══════════ Toast ══════════ */
export let toastTimer;
export function toast(msg) {
  const t = $('#toast');
  t.textContent = msg;
  t.classList.remove('hidden');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.add('hidden'), 2600);
}

/* Erfolgs-Benachrichtigung unten links (mit Warteschlange) */
/* ══════════ Benachrichtigungen unten rechts (Erfolg · Level · Accessoire) ══════════ */
export let achQueue = [], achBusy = false;
export function pushPop(item) { achQueue.push(item); if (!achBusy) nextAchPop(); }
export function nextAchPop() {
  const el = $('#ach-pop');
  if (!achQueue.length) { achBusy = false; el.classList.add('hidden'); return; }
  achBusy = true;
  const it = achQueue.shift();
  el.classList.remove('hidden', 'hide');
  el.innerHTML = `<img class="pop-ico" src="${it.img}" alt="">
    <div><div class="pop-eyebrow">${esc(it.eyebrow)}</div>
      <div class="pop-name">${esc(it.name)}</div>
      ${it.reward ? `<div class="pop-reward">${esc(it.reward)}</div>` : ''}</div>`;
  el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
  setTimeout(() => { el.classList.add('hide'); setTimeout(() => { el.classList.remove('hide'); nextAchPop(); }, 300); }, 3400);
}
/* Erfolg (inkl. freigeschaltetem Accessoire in der Belohnungszeile) */
export function achPop(a) {
  const reward = [a.acc ? '🎀 Accessoire: ' + (accById(a.acc)?.name || '') : '', a.xp ? `+${a.xp} XP` : ''].filter(Boolean).join(' · ');
  pushPop({ img: `assets/${a.icon ? 'icon_' + a.icon : 'icon_trophy'}.png`, eyebrow: 'Erfolg freigeschaltet', name: a.name, reward });
}
/* Level-Aufstieg */
export const BUDDY_MILESTONES = [5, 10, 20, 50, 100, 200, 500, 1000];
export function levelPop(level, gems, milestone) {
  const g = gems || 1;
  pushPop({ img: 'assets/icon_trophy.png', eyebrow: milestone ? `Meilenstein · Level ${level}! 🌟` : 'Level aufgestiegen', name: `Level ${level} erreicht`, reward: `💎 +${g} Diamant${g > 1 ? 'en' : ''}${milestone ? ' · Meilenstein!' : ''} · weiter so! 🌱` });
}

export const LEVEL_COLOR = { red: '#ff9fb0', yellow: '#ffd67e', green: '#9fdcb4' };
export const LEVEL_NAME = { red: 'Rot', yellow: 'Gelb', green: 'Grün' };

/* ══════════ 8-bit Sound ══════════ */
export let actx;
export function beep(freq, dur, type = 'square', vol = 0.05, when = 0) {
  if (localStorage.getItem('snd') === '0') return;
  try {
    actx = actx || new (window.AudioContext || window.webkitAudioContext)();
    if (actx.state === 'suspended') actx.resume();
    const t = actx.currentTime + when;
    const o = actx.createOscillator(), g = actx.createGain();
    o.type = type; o.frequency.value = freq;
    o.connect(g); g.connect(actx.destination);
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.start(t); o.stop(t + dur);
  } catch {}
}
export const SFX = {
  flip: () => beep(600, 0.05),
  again: () => beep(150, 0.2, 'sawtooth', 0.05),
  hard: () => beep(320, 0.1),
  good: () => { beep(660, 0.08); beep(880, 0.1, 'square', 0.05, 0.08); },
  easy: () => { beep(660, 0.06); beep(990, 0.06, 'square', 0.05, 0.06); beep(1320, 0.1, 'square', 0.05, 0.12); },
  win: () => [523, 659, 784, 1047].forEach((f, i) => beep(f, 0.12, 'square', 0.05, i * 0.09)),
  unlock: () => [784, 988, 1319].forEach((f, i) => beep(f, 0.14, 'triangle', 0.06, i * 0.1)),
  // absteigendes „Zurückspul"-Geräusch fürs Zurücknehmen
  undo: () => [660, 520, 400, 300].forEach((f, i) => beep(f, 0.09, 'sine', 0.06, i * 0.05)),
};

